import { ThemeTokens } from './types';

export const light_theme_tokens: ThemeTokens = {
	risk_colors: {
		low: {
			default: '#17A93B',
			200: '#B7E4C2',
			100: '#E8F6EB'
		},
		medium: {
			default: '#FFB40A',
			200: '#FFE8B3',
			100: '#FFF8E7'
		},
		moderate: {
			default: '#F2751C',
			200: '#FBD4B9',
			100: '#FEF1E8'
		},
		high: {
			default: '#D13342',
			200: '#F1C0C4',
			100: '#FAEBEC'
		},
		very_high: {
			default: '#7828C8',
			200: '#D5BCEE',
			100: '#F2EAFA'
		}
	},

	primary_colors: {
		50: '#F7F8FD',
		100: '#E6EAF8',
		200: '#B0BFEA',
		400: '#5474D1',
		500: '#455ED6',
		600: '#2F54EB',
		default: '#002FBB',
		700: '#002185',
		800: '#00144F'
	},

	secondary_colors: {
		white: '#FFFFFF',
		50: '#F8F8F8',
		100: '#F0F0F0',
		150: '#E6E6E6',
		200: '#D9D9D9',
		250: '#BFBFBF',
		300: '#8C8C8C',
		400: '#262626',
		500: '#505050'
	},

	border_radius: {
		br_xs: '2px',
		br_sm: '4px',
		br_md: '6px',
		br_lg: '8px',
		br_xl: '10px'
	},

	font_sizes: {
		fs_xs: '14px',
		fs_sm: '16px',
		fs_md: '18px',
		fs_lg: '20px',
		fs_2xl: '25px',
		fs_3xl: '31.25px',
		fs_4xl: '39.06px',
		fs_5xl: '48.83px'
	},

	font_weights: {
		regular: 400,
		semibold: 600
	},

	line_heights: {
		lh_xs: '16px',
		lh_sm: '20px',
		lh_md: '24px',
		lh_lg: '32px',
		lh_xl: '40px',
		lh_2xl: '48px',
		lh_3xl: '56px',
		lh_4xl: '72px'
	},

	letter_spacings: {
		ls_xs: '-1.5%',
		ls_sm: '-1%',
		ls_md: '-0.5%',
		ls_lg: '0',
		ls_xl: '0.5%',
		ls_2xl: '1%',
		ls_3xl: '1.5%'
	}
};
